/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_HintInputs */

const en_us2_body_assessment_reference_hint = /** @type {(inputs: Body_Assessment_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you had a body-composition test today, enter the result: it calibrates your later estimates and narrows the range.`)
};

const pt_br2_body_assessment_reference_hint = /** @type {(inputs: Body_Assessment_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se você fez um exame de composição corporal hoje, informe o resultado: ele calibra as suas próximas estimativas e estreita a faixa.`)
};

const es_419_body_assessment_reference_hint = /** @type {(inputs: Body_Assessment_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si hoy te hiciste un estudio de composición corporal, ingresa el resultado: calibra tus próximas estimaciones y reduce el rango.`)
};

const pt_pt2_body_assessment_reference_hint = /** @type {(inputs: Body_Assessment_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se fizeste hoje um exame de composição corporal, indica o resultado: calibra as tuas próximas estimativas e estreita o intervalo.`)
};

const fr_fr2_body_assessment_reference_hint = /** @type {(inputs: Body_Assessment_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu as fait un examen de composition corporelle aujourd'hui, saisis le résultat : il calibre tes prochaines estimations et resserre la fourchette.`)
};

const de_de2_body_assessment_reference_hint = /** @type {(inputs: Body_Assessment_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du heute eine Körperzusammensetzung messen lassen hast, gib das Ergebnis ein: Es kalibriert deine späteren Schätzungen und macht die Spanne enger.`)
};

const it_it2_body_assessment_reference_hint = /** @type {(inputs: Body_Assessment_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se oggi hai fatto un esame della composizione corporea, inserisci il risultato: calibra le tue stime successive e restringe l'intervallo.`)
};

/**
* | output |
* | --- |
* | "If you had a body-composition test today, enter the result: it calibrates your later estimates and narrows the range." |
*
* @param {Body_Assessment_Reference_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_hint = /** @type {((inputs?: Body_Assessment_Reference_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_hint(inputs)
	return en_us2_body_assessment_reference_hint(inputs)
});
export { body_assessment_reference_hint as "body-assessment.reference_hint" }